export default "__VITE_ASSET__C3V_PBIV__"